export type GroupJoinRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';
export type GroupRole = 'OWNER' | 'MEMBER' | 'VIEWER';

export class JoinRequest {
  constructor(
    public id: number,
    public researchGroupId: number,
    public researchGroupName: string,
    public userId: number,
    public userEmail: string,
    public firstName: string,
    public lastName: string,
    public status: GroupJoinRequestStatus,
    public createdAt: string,
  ) {}

  get userName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get email(): string {
    return this.userEmail;
  }
}
